<nb-card>
  <nb-card-body>
    <div class="row" *ngIf="this.data.room && this.authService.hasRole('quality-control:read')"  >
      <div class="col-12">
        <button mat-raised-button class="actionButton" (click)="goToQC();">View QC
          <fa-icon style="margin-left: 5px;" size="lg" [icon]="faFlask"></fa-icon>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button mat-raised-button class="actionButton marginTop" style="white-space: nowrap;" (click)="openStoragePlanPopup();">Open {{"Storage Plans" | tenantWords}}
          <span><fa-icon style="margin-left: 5px;" size="lg" [icon]="faCalendarAlt"></fa-icon></span>
        </button>
      </div>
    </div>
    <div class="row" *ngIf="this.data.room">
      <div class="col-12">
        <button mat-raised-button class="actionButton marginTop" (click)="createStoragePlanForRoomPopup();">Create {{"Storage Plan" | tenantWords}}
          <fa-icon style="margin-left: 5px;" size="lg" [icon]="faCalendarAlt"></fa-icon>
        </button>
      </div>
    </div>
    <div class="row" *ngIf="this.data.room">
      <div class="col-12">
        <button mat-raised-button class="actionButton marginTop" (click)="editRoom();">Edit {{"Room" | tenantWords}} Details
          <fa-icon style="margin-left: 5px;" size="lg" [icon]="faWarehouseAlt"></fa-icon>
        </button>
      </div>
    </div>
    
  </nb-card-body>
</nb-card>